import TableBody from '@mui/material/TableBody'
import { observer } from 'mobx-react'
import React from 'react'
import TableBodyRow from 'src/utils/components/CustomTable/components/CustomTableBody/TableBodyRow'

function CustomTableBody({
  rows,
  columns,
  onRowClick,
  closeAdditionalInfo,
  additionalRowCells,
  additionalRowPropName,
  total,
  setCurrentOpenedRowIndex,
  currentOpenedRowIndex,
  redDelete,
  toggleIsRowOpen,
}) {
  const [] = React.useState()
  return (
    <>
      <TableBody>
        {rows.map((row, index) => {
          return (
            <TableBodyRow
              key={`${Date.now()}_${index}`}
              row={row}
              columns={columns}
              rowIndex={index}
              onRowClick={onRowClick}
              closeAdditionalInfo={closeAdditionalInfo}
              additionalRowCells={additionalRowCells}
              additionalRowPropName={additionalRowPropName}
              total={total}
              setCurrentOpenedRowIndex={setCurrentOpenedRowIndex}
              currentOpenedRowIndex={currentOpenedRowIndex}
              redDelete={redDelete}
              toggleIsRowOpen={toggleIsRowOpen}
            />
          )
        })}
      </TableBody>
    </>
  )
}

export default observer(CustomTableBody)
